export default __webpack_public_path__ + "static/media/me1.339ff3d9.png";